import { Protocol } from '../Protocol';

export class MaterialCodeProtocol {

  public static readonly ALL_MATERIAL_TYPE: string = `${Protocol.YATUNG_API_ROOT}/receipt/material/type/all`; // 取得所有入料類型
  public static readonly MATERIAL_TYPE_URL: string = `${Protocol.YATUNG_API_ROOT}/receipt/material/type`; // 修改 & 新增入料類型

}
